/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import SearchRegistrationIdSubUserForm from '../../components/forms/SearchRegistrationIdSubUserForm';
import {
  searchSubUserByRegistrationId,
  clearMessage,
  editSubUserProductPricesBySubUserId,
  resetState,
} from './actions';
import { useDispatch, useSelector } from 'react-redux';
import GridCell from '../../components/elements/GridCell';
import IconStore from '../../components/icons/IconStore';
import { Stack, Modal, CloseButton, Flex, Loader } from '@mantine/core';
import Button from '../../components/elements/Button';
import { thousand } from '../../utils/format';
import SubUserEditPriceForm from '../../components/forms/SubUserEditPriceForm';
import styles from './styles.scoped.css';

export function FormByRegistrationId() {
  const dispatch = useDispatch();
  const {
    dataSearchSubUserByRegistrationId,
    isLoadingSearchSubUserByRegistrationId,
    messageSearchSubUserByRegistrationId,
    dataEditSubUserProductPricesBySubUserId,
    dataBaseGeneralPrices
  } = useSelector((s) => s.prices);
  const [modalAct, setModalAct] = useState('');
  const [modalData, setModalData] = useState({});
  const gridProps = { left: 4, right: 8 };
  const gridData = [
    {
      data: dataSearchSubUserByRegistrationId?.registrationId,
      label: 'ID Registrasi Subpangkalan',
      ...gridProps,
    },
    {
      data: dataSearchSubUserByRegistrationId?.registrationDate,
      label: 'Tanggal',
      ...gridProps,
    },
    {
      data: dataSearchSubUserByRegistrationId?.registrationTime,
      label: 'Jam Registrasi',
      ...gridProps,
    },
  ];

  const handleSearch = (val) => {
    return dispatch(searchSubUserByRegistrationId(val.registrationId));
  };
  const handleEditPrice = (values) => {
    handleClose();
    return dispatch(editSubUserProductPricesBySubUserId(values));
  };
  const handleReset = (key) => {
    return dispatch(clearMessage(key));
  };
  const handleModal = (key) => {
    setModalAct(key);
    key === 'edit-price' &&
      setModalData({
        minPrice: dataSearchSubUserByRegistrationId.minPrice,
        maxPrice: dataSearchSubUserByRegistrationId.maxPrice,
        subUserId: dataSearchSubUserByRegistrationId.subUserId,
      });
  };
  const handleClose = () => {
    setModalAct('');
    setModalData({});
  };

  useEffect(() => {
    if (dataEditSubUserProductPricesBySubUserId) {
      handleClose();
      handleSearch({ registrationId: dataSearchSubUserByRegistrationId.registrationId });
    }
  }, [dataEditSubUserProductPricesBySubUserId]);

  useEffect(() => {
    return () => {
      dispatch(resetState('SearchSubUserByRegistrationId'));
    };
  }, []);

  return (
    <>
      <SearchRegistrationIdSubUserForm
        handleReset={() => handleReset('SearchSubUserByRegistrationId')}
        handleSubmit={handleSearch}
        message={messageSearchSubUserByRegistrationId}
      />
      {isLoadingSearchSubUserByRegistrationId && (
        <Flex align="center" justify="center" mb={'4rem'} mt={'5.5rem'}>
          <Loader size="lg" variant="dots" />
        </Flex>
      )}
      {Object.keys(dataSearchSubUserByRegistrationId).length > 0 &&
        !isLoadingSearchSubUserByRegistrationId && (
          <div style={{ marginTop: '1.5rem' }}>
            <span>
              Menampilkan data berdasarkan pencarian <strong>"ID Registrasi"</strong>
            </span>
            <div className={styles['sub-user-container']}>
              <div className={styles['sub-user-header']}>
                <IconStore />
                <span>{dataSearchSubUserByRegistrationId?.name}</span>
              </div>
              <div className={styles['sub-user-content']}>
                {gridData.map((item, i) => (
                  <GridCell key={i} {...item} />
                ))}
              </div>
              <hr className={styles.separator} style={{ margin: 0 }} />
              <div className={styles['sub-user-prices']}>
                <Stack>
                  <span>Harga Jual Minimum</span>
                  <span>{`Rp${thousand(dataSearchSubUserByRegistrationId?.minPrice)}`}</span>
                </Stack>
                <Stack>
                  <span>Harga Jual Maksimum</span>
                  <span>{`Rp${thousand(dataSearchSubUserByRegistrationId?.maxPrice)}`}</span>
                </Stack>
                <Button onClick={() => handleModal('edit-price')}>
                  Ubah Harga HET
                </Button>
              </div>
            </div>
          </div>
        )}
      <Modal
        centered
        isLoading
        onClose={() => setModalAct('')}
        opened={modalAct === 'edit-price'}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles['modal-container']}>
          <div className={styles['modal-header']}>
            <h5>Edit Harga HET Subpangkalan</h5>
            <span onClick={handleClose}>
              <CloseButton />
            </span>
          </div>
          <SubUserEditPriceForm
            handleClose={handleClose}
            handleSubmit={handleEditPrice}
            initialValues={modalData}
            productGeneralMaxPrice={dataBaseGeneralPrices?.productGeneralMaxPrice}
            productGeneralMinPrice={dataBaseGeneralPrices?.productGeneralMinPrice}
          />
        </div>
      </Modal>
    </>
  );
}
